<template>
  <span
    class="skeleton"
    :class="{ paused, scale }"
    :style="{ height, width }"
  />
</template>

<script>
export default {
  name: 'Skeleton',
  props: {
    height: {
      default: '16px',
      type: [String, Number]
    },
    width: {
      default: '100%',
      type: [String, Number]
    },
    paused: {
      type: Boolean,
      default: false
    },
    scale: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss">
.skeleton {
  display: inline-block;
  position: relative;
  vertical-align: middle;
  overflow: hidden;
  background-color: $gray-bg;
  max-width: 100%;
  max-height: 100%;
  border-radius: 3px;

  &.scale {
    transform-origin: 0 0;
    animation: scale 800ms linear infinite alternate;
    &:nth-child(even) {
      animation-direction: alternate-reverse;
    }
  }

  &:after {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    transform: translateX(-100%);
    background-image: linear-gradient(
      90deg,
      rgba($white, 0) 0,
      rgba($white, 0.2) 20%,
      rgba($white, 0.5) 60%,
      rgba($white, 0)
    );
    animation: shimmer 1.2s infinite;
  }
  &.paused {
    &:after {
      animation-play-state: paused;
    }
  }

  @keyframes scale {
    0% {
      transform: scaleX(0.95);
    }
    100% {
      transform: scaleX(1);
    }
  }

  @keyframes shimmer {
    100% {
      transform: translateX(100%);
    }
  }
}
</style>
